/**
 * pdp-reviews-grid.js
 * Handles "Load More Reviews" progressive disclosure for the reviews grid section.
 * Vanilla JS — no jQuery dependency.
 */

(function () {
  const CARDS_PER_PAGE = 6;

  function initReviewsGrid(section) {
    const loadMoreBtn = section.querySelector('[data-load-more]');
    if (!loadMoreBtn) return;

    const allCards = Array.from(
      section.querySelectorAll('.pdp-reviews-grid__card')
    );

    if (allCards.length === 0) return;

    let visibleCount = CARDS_PER_PAGE;

    function updateVisibility() {
      allCards.forEach(function (card, index) {
        if (index < visibleCount) {
          card.classList.remove('pdp-reviews-grid__card--hidden');
          card.removeAttribute('aria-hidden');
        } else {
          card.classList.add('pdp-reviews-grid__card--hidden');
          card.setAttribute('aria-hidden', 'true');
        }
      });

      // Hide button when all cards are visible
      if (visibleCount >= allCards.length) {
        loadMoreBtn.style.display = 'none';
      } else {
        loadMoreBtn.style.display = '';
      }
    }

    // Initial render
    updateVisibility();

    loadMoreBtn.addEventListener('click', function () {
      visibleCount += CARDS_PER_PAGE;
      updateVisibility();

      // Shift focus to first newly revealed card for accessibility
      var nextCard = allCards[visibleCount - CARDS_PER_PAGE];
      if (nextCard) {
        nextCard.setAttribute('tabindex', '-1');
        nextCard.focus({ preventScroll: false });
      }
    });
  }

  function init() {
    var sections = document.querySelectorAll('.pdp-reviews-grid');
    sections.forEach(function (section) {
      initReviewsGrid(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support — re-init when section is updated
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.pdp-reviews-grid');
    if (section) initReviewsGrid(section);
  });
})();
